import React, {useState} from 'react'
import './../css/Login.css'
import { Link, useNavigate } from 'react-router-dom';

import PageTitle from './../includes/PageTitle';
import { signInWithEmailAndPassword, sendEmailVerification, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './../../firebase/firebaseConfig';




export default function SignIn() {
    const [passwordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (!user.emailVerified) {
        setErrorMessage('Your email is not verified. Please verify your email before signing in.');
        sendEmailVerification(user);
        setLoading(false);
        return;
      }

      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();
        if (userData.role !== 'admin') {
          setErrorMessage('You do not have permission to access this area.');
          await signOut(auth);
          setLoading(false);
          navigate('/products');
          return;
        }
      } else {
        setErrorMessage('User data not found.');
        await signOut(auth);
        setLoading(false);
        return;
      }

      navigate('/a/dashboard');
    } catch (error) {
      setErrorMessage(handleFirebaseError(error.code));
      setLoading(false);
    }
  };

  const handleFirebaseError = (errorCode) => {
    switch (errorCode) {
      case 'auth/invalid-email':
        return 'Invalid email format.';
      case 'auth/user-disabled':
        return 'This account has been disabled.';
      case 'auth/user-not-found':
        return 'No user found with this email.';
      case 'auth/wrong-password':
        return 'Incorrect password.';
      default:
        return 'An error occurred. Please try again.';
    }
  };
  return (
    <>
      <PageTitle title="Sign In - ALMOSTINVISIBLE" />
      <div style={{ marginTop: "5vh", display: "flex", justifyContent: "center" }}>
        <form className="form" onSubmit={handleSignIn}>
          
          <h1 className="unbounded black-bordered-bottom">SIGN IN</h1>
        

          {errorMessage && (
            <div className="alert alert-danger alert-dismissible fade show mt-3" role="alert">
              {errorMessage}
              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          )}

          <div>
            <div className="flex-column">
              <label className='nunito-2'>Email*</label>
            </div>
            <div className="inputForm">
              <input
                type="email"
                className="input"
                placeholder="Enter your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div>
            <div className="flex-column">
              <label className='nunito-2'>Password*</label>
            </div>
            <div className="inputForm">
              <input
                type={passwordVisible ? 'text' : 'password'}
                className="input"
                placeholder="Enter your Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <svg viewBox="0 0 576 512" height="1em" style={{ cursor: "pointer" }} onClick={togglePasswordVisibility} xmlns="http://www.w3.org/2000/svg">
                <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
              </svg>
            </div>
          </div>

          <div className="flex-row">
            <div>
              <input type="checkbox" />
              <label>Remember me </label>
            </div>
            <Link to="/forgot-password" className="span">Forgot password?</Link>
          </div>

          <div className="d-flex justify-content-center mt-3">
          <button className="black-button" type="submit" disabled={loading}>
              Sign In 
              {loading &&
                <>
                  &nbsp;
                  <div className="spinner-border spinner-border-sm" role="status"></div>
                </>
                
              }
          </button>
          </div>
        </form>
      </div>
    </>
  )
}
